import { TestimonialCarousel } from "./testimonial";
import feenImg from "../../assets/favicon.png";

const TESTIMONIALS = [
  {
    id: 1,
    name: "Feen Art",
    avatar: feenImg,
    description:
      "Un travail exceptionnel : le site est rapide, moderne et très efficace pour convertir nos visiteurs en clients. Le design inspire immédiatement confiance.",
  },
  {
    id: 2,
    name: "Client — projet SEO",
    avatar: "https://randomuser.me/api/portraits/lego/4.jpg",
    description:
      "Très pro du début à la fin : design soigné, SEO bien structuré, et un vrai suivi après la mise en ligne.",
  },
  {
    id: 3,
    name: "Web4jobs",
    avatar: "https://randomuser.me/api/portraits/lego/2.jpg",
    description:
      "Le système de gestion des utilisateurs est intuitif et parfaitement adapté à notre cahier des charges. Une solution fiable et bien développée.",
    role: "Responsable IT",
  },
];

export function TestimonialSection() {
  return (
    <section id="testimonials" className="relative w-full bg-surface py-20 md:py-32">
      <div className="pointer-events-none absolute inset-0 bg-hero-glow opacity-25" aria-hidden />
      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mx-auto mb-12 max-w-2xl text-center md:mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Avis</p>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl md:text-5xl">
            Ils me font confiance
          </h2>
          <p className="mt-4 text-balance text-base text-zinc-500 sm:text-lg">
            Des retours authentiques sur la qualité du travail et l’accompagnement.
          </p>
        </div>

        <TestimonialCarousel testimonials={TESTIMONIALS} className="mx-auto max-w-3xl" />
      </div>
    </section>
  );
}
